import { useSecurityContext } from '@components/Navigation/SecurityContext'
import { useModelConfig } from '@hooks/useModelConfig'
import { useMemo } from 'react'

export const useCanViewEbols = () => {
  const { config } = useModelConfig()

  //todo: figure out role/config name
  return useMemo(() => config?.ebol_config?.enabled, [config])
}
